const { registerBlockType } = wp.blocks;

const { Fragment } = wp.element;
const { InspectorControls,InnerBlocks  } = wp.editor;
const { PanelBody, TextControl,CheckboxControl  } = wp.components;

registerBlockType(contentlink_data.suffix+'/content-link',{
	title:contentlink_data.lang.title,
	icon: 'format-image',
    category: 'widgets',
    className:'content-link',
    supports:{
        align:true,
    },
    attributes:{
        link:{
            type:'string',
            default:''
        },
        target:{
            type:'string',
            default:''
        },
        noopener:{
            type:'boolean',
            default:false
        }
    },
	edit:(props) => {
            return <Fragment>
                        <div style={{padding:'1rem',backgroundColor:'#f0f0f0'}} >
                            <InnerBlocks />
                        </div>
                        <InspectorControls>
                            <PanelBody>
                                <h3>Options</h3>
                                <TextControl 
                                    label="Cible du lien"
                                    value={ props.attributes.link }
                                    onChange={ ( val ) => props.setAttributes( { link:val} ) }
                                />
                                <TextControl 
                                    label="target"
                                    value={ props.attributes.target }
                                    onChange={ ( val ) => props.setAttributes( { target:val} ) }
                                />
                                <CheckboxControl 
                                    label="Noopener"
                                    checked={ props.attributes.noopener }
                                    onChange={ ( val ) => props.setAttributes( { noopener:val} ) }
                                />
                            </PanelBody>
                        </InspectorControls>
                    </Fragment>
    },
    save:(props) 	=> {
        return  <a href={props.attributes.link} target={props.attributes.target} rel={props.attributes.noopener?"noopener":""} >
                    <InnerBlocks.Content />
                </a>
    }, 
});